const GameMetrics = {
  GridSize: 9,
  SubGridSize: 3,
  TileSize: 38,
  MaxCellsWithPoints: 3,
  GameShapeCount: 3,
  PointsPerGridElement: 20,
  PointsPerBlock: 1,
  PointsPerBlockOnWin: 1000,
  SpawnPoints: 50,
  MaxStage: 26,
} as const;

export default GameMetrics;
